import { Divider } from '@tvg/fuse-design/divider';
import { GridItem, GridRow, gridConfig } from '@tvg/fuse-design/responsive-grid';
import React from 'react';
import styled from 'styled-components';
import ProductsPerPage from './ProductsPerPage/ProductsPerPage';
import ResultCount from './ResultCount';

const BottomRowStyled = styled(GridRow)`
  &.bottom-row {
    @media screen and (min-width: ${gridConfig.xxs.minWidth}) {
      margin-top: var(--spacing-space40);
      margin-bottom: var(--spacing-space12);
    }

    @media screen and (min-width: ${gridConfig.m.minWidth}) {
      margin-top: var(--spacing-space48);
    }

    @media screen and (min-width: ${gridConfig.l.minWidth}) {
      margin-top: var(--spacing-space64);
    }
  }
`;

const StyledGridItem = styled(GridItem)`
  display: grid;

  &.results-grid-item-bottom {
    @media screen and (max-width: ${gridConfig.m.maxWidth}) {
    }
  }
`;

const DividerStyled = styled(Divider)`
  &.results-divider-bottom {
    @media screen and (min-width: ${gridConfig.l.minWidth}) {
      padding-top: var(--spacing-space16);
      padding-bottom: 0;
      margin-bottom: var(--spacing-space4);
    }
  }
`;

const ResultWrapper = styled.div`
  & {
    display: inline-flex;
    align-self: center;
  }
`;

function BottomRowComponent() {
  return (
    <BottomRowStyled className="row bottom-row">
      <GridItem xxs="12" l="12">
        <GridRow>
          <GridItem xxs="12" l="12">
            <ResultWrapper>
              <ResultCount position="bottom" />
              <ProductsPerPage position="bottom" />
            </ResultWrapper>
          </GridItem>
        </GridRow>
      </GridItem>

      <StyledGridItem xxs="12" className="results-grid-item-bottom">
        <DividerStyled className="results-divider-bottom" />
      </StyledGridItem>
    </BottomRowStyled>
  );
}

export const BottomRow = React.memo(BottomRowComponent);
